import React, { memo } from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import NoQuestionsResult from './NoQuestionsResult/NoQuestionsResult';
import QuestionsResultsFound from './QuestionsResultsFound/QuestionsResultsFound';
import {
  useQuestions,
  areQuestionsEqual,
} from '../../../../hooks/useQuestions';
import { st, classes } from '../Widget.st.css';
import { DATA_HOOKS } from '../../../../constants/dataHooksElements';

export interface Props {
  questions: QuestionEntry[];
  fetchError?: Error | null;
  searchTerm?: string;
  numberLayout?: boolean;
  accordionLayout?: boolean;
  listLayout?: boolean;
}

const DEFAULT_ACCORDION_LAYOUT = true;

const QuestionsWrapperComponent = ({
  questions,
  fetchError,
  searchTerm,
  numberLayout = false,
  accordionLayout = DEFAULT_ACCORDION_LAYOUT,
  listLayout = false,
}: Props) => {
  const { questionsList, bottomRef } = useQuestions(questions);

  if (fetchError) {
    return null;
  }
  return (
    <>
      {questionsList.length > 0 ? (
        <QuestionsResultsFound
          questionsList={questionsList}
          searchTerm={searchTerm ?? ''}
          numberLayout={numberLayout}
          accordionLayout={accordionLayout}
          listLayout={listLayout}
        />
      ) : (
        <NoQuestionsResult />
      )}
      <div
        data-hook={DATA_HOOKS.QUESTIONS_WRAPPER}
        ref={bottomRef}
        className={st(classes.bottomBody)}
      />
    </>
  );
};

const QuestionsWrapper = memo(
  QuestionsWrapperComponent,
  (prev, next) =>
    areQuestionsEqual(prev.questions, next.questions) &&
    prev.fetchError === next.fetchError &&
    (prev.searchTerm ?? '') === (next.searchTerm ?? '') &&
    prev.numberLayout === next.numberLayout &&
    prev.accordionLayout === next.accordionLayout &&
    prev.listLayout === next.listLayout,
);

export default QuestionsWrapper;
